// dashboard-model.js

import { Model } from 'backbone';

class DashboardModel extends Model {

    initialize() {
    }

    defaults() {
        return {};
    }


    parse(response, options)  {
        return response;
    }
}

export default DashboardModel;
